import React from 'react';
import {
  useDataModel, params, string, json
} from '@thd-nucleus/data-sources';
import { string as stringType } from 'prop-types';
import cx from 'classnames';
import {
  Card,
  CardContent,
  Link,
  Typography
} from '@one-thd/sui-atomic-components';

import { RentalsServicesSkeleton } from '../subcomponents/Skeletons';
import { PAGE_NAMES } from '../../constants';

const RentalServicesInformation = ({ contentId, className = '' }) => {
  const { data, loading, error } = useDataModel('emtContent', {
    variables: {
      contentId,
      pageName: PAGE_NAMES.RENTALS
    },
    skip: !contentId
  });
  const services = data?.emtContent?.content?.rentalsInformation?.rentals;

  if (loading) return <RentalsServicesSkeleton />;

  if (!data || error || !services || services?.length === 0) return null;

  return (
    <div
      data-component="RentalServicesInformation"
      className={cx('sui-flex sui-flex-col sui-gap-4', className)}
    >
      <Typography variant="h2" weight="display">Tools & Truck Rentals at The Home Depot Near You</Typography>
      <div className="sui-grid sui-grid-cols-1 md:sui-grid-cols-2 lg:sui-grid-cols-3 sui-gap-8">
        { services?.map((service, index) => (
          <CardService
            key={`rental-service-card-${index}`}
            imageUrl={service?.imageUrl}
            category={service?.category}
            rentalItems={service?.rentalItems}
          />
        ))}
      </div>
    </div>
  );
};

const CardService = ({ imageUrl = '', category = '', rentalItems = '' }) => {
  const imageSrc = imageUrl?.includes('https') || imageUrl?.includes('dam.')
    ? imageUrl
    : `//assets.thdstatic.com/mcstore/images/rentals/${imageUrl}`;

  return (
    <Card grow>
      <CardContent disablePadding>
        <img
          height="170"
          width="100%"
          src={imageSrc}
          title={category}
          alt={category}
          className="sui-overflow-hidden sui-object-cover sui-max-h-40 sui-min-h-32"
        />
        <Typography variant="h2">{category}</Typography>
        <ul className="sui-flex sui-flex-col sui-gap-2">
          {rentalItems?.map((item, i) => (
            <li key={`rental-item-${i}`}>
              <Link href={item?.link}>
                {item?.rental.replace('&amp;', '&')}
              </Link>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

RentalServicesInformation.displayName = 'RentalServices';

RentalServicesInformation.dataModel = {
  emtContent: params({
    contentId: string().isRequired(),
    pageName: string().isRequired()
  }).shape({
    content: json()
  })
};

export default RentalServicesInformation;